import script from "./Tasks.vue?vue&type=script&setup=true&lang=js"
export * from "./Tasks.vue?vue&type=script&setup=true&lang=js"

import "./Tasks.vue?vue&type=style&index=0&id=585b6c0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585b6c0a"]])

export default __exports__